module.exports = __webpack_public_path__ + "img/demo_food-600x450.4f83d423.png";